// @flow
import type { Plane, PlaneEntity } from '../types';
import { TYPE } from '../constants/targetConstants';
import makeTargetReducer from './_makeTargetReducer';
import type { State as TargetState } from './_makeTargetReducer';

export type State = TargetState<Plane, PlaneEntity>;

const getDataSource = () => 'system';

export default makeTargetReducer({ type: TYPE.plane, getDataSource });